import { fetchEventSource } from '@microsoft/fetch-event-source';
import { TokenUtils } from '@/utils/TokenUtils';

export default {
  namespaced: true,
  state: {
    deliveryNotifications: 0,
    abortController: null,
  },
  mutations: {
    CONNECT(state) {
      if (state.abortController) return;
      state.abortController = new AbortController();
      fetchEventSource(`${process.env.VUE_APP_BASEURL_ALMACEN}/v1/notifications/stream/pos`, {
        headers: { Authorization: `Bearer ${TokenUtils.getToken()}` },
        signal: state.abortController.signal,
        onmessage: (e) => {
          state.deliveryNotifications = 0;
          // eslint-disable-next-line camelcase
          const { pos_notifications_count } = JSON.parse(e.data);
          // eslint-disable-next-line camelcase
          state.deliveryNotifications += pos_notifications_count;
        },
        onerror: (err) => {
          console.error('EventSource failed:', err);
          if (err?.message?.includes('401')) throw err;
        },
      });
    },
  },
  actions: {
    connect({ commit }) {
      commit('CONNECT');
    },
    disconnect({ state }) {
      if (state.abortController) {
        state.abortController.abort();
        state.abortController = null;
      }
    },
  },
  getters: {
    notificationCount(state) {
      return state.deliveryNotifications;
    },
  },
};
